<div class="card selected-event-card">
  <div class="card-body">
    <h5>{{ 'registration_selectedOtEvent' | l10n }}</h5>
    <div class="infoCard-action" *ngIf="changable">
      &raquo; <a [routerLink]="['/city/' + otEvent.room.venue.city?.id + '/ot/event/list']">{{ 'registration_change' | l10n }}</a>
    </div>
    <div class="info-list">
      <div>
        <div class="label">{{ 'otEvent_name' | l10n }}</div>
        <div class="ot-event-name">{{ otEvent.name }}</div>
      </div>
      <div>
        <div class="label">{{ 'otEvent_dayOfWeek' | l10n }}</div>
        <div>{{ otEvent.startDate?.getDay() | dayOfWeek }}<span *ngIf="otEvent.startDate !== null">, {{ otEvent.startDate | localizedDate }}</span></div>
      </div>
      <div>
        <div class="label">{{ 'otEvent_timeFromTo' | l10n }}</div>
        <div>{{ otEvent.startTime | time }} &ndash; {{ otEvent.endTime | time }}</div>
      </div>
      <div *ngIf="otEvent.description">
        <div class="label">{{ 'otEvent_description' | l10n }}</div>
        <div>{{ otEvent.description }}</div>
      </div>
      <div>
        <div class="label">{{ 'otEvent_venue' | l10n }}</div>
        <div>
          <!-- <div>
            {{ otEvent.room.venue.name }}
            <span *ngIf="otEvent.room.name && otEvent.room.name !== '-'">&ndash; {{ otEvent.room.name }}</span>
          </div> -->
          <div>
            <span *ngIf="otEvent.room.venue.street">{{ otEvent.room.venue.street }}, </span>
            {{ otEvent.room.venue.city.name }}
          </div>
        </div>
      </div>
      <div *ngIf="otEvent.teacher && otEvent.teacher.id">
        <div class="label">{{ 'otEvent_teacher' | l10n }}</div>
        <div *ngIf="otEvent.teacher.profilePictureName || otEvent.teacher.profileText"><a (click)="showTeacherProfile(otEvent.teacher)">{{ otEvent.teacher.displayName }}</a>&nbsp;<span class="fa fa-user-o"></span></div>
        <div *ngIf="! otEvent.teacher.profilePictureName && ! otEvent.teacher.profileText">{{ otEvent.teacher.displayName }}</div>
      </div>
      <div>
        <div class="label">{{ 'otEvent_organization' | l10n }}</div>
        <div><a href="#/organization/{{ otEvent.organization.id }}" target="_blank">{{ otEvent.organization.name }} <span class="fa fa-external-link"></span></a></div>
      </div>
    </div>
  </div>
</div>
